'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Validator2 = require('./Validator');

var _Validator3 = _interopRequireDefault(_Validator2);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PresenceValidator = function (_Validator) {
  _inherits(PresenceValidator, _Validator);

  function PresenceValidator() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        message = _ref.message,
        _ref$allowEmpty = _ref.allowEmpty,
        allowEmpty = _ref$allowEmpty === undefined ? false : _ref$allowEmpty;

    _classCallCheck(this, PresenceValidator);

    var _this = _possibleConstructorReturn(this, (PresenceValidator.__proto__ || Object.getPrototypeOf(PresenceValidator)).call(this));

    _this.message = message;
    _this.allowEmpty = allowEmpty;
    return _this;
  }

  _createClass(PresenceValidator, [{
    key: 'validate',
    value: function validate(value, attribute, model) {
      if (this.allowEmpty ? !_utils2.default.isDefined(value) : _utils2.default.isEmpty(value)) {
        return Promise.reject(this.createMessage(this.message || PresenceValidator.MESSAGE, {
          attribute: attribute
        }));
      }
      return Promise.resolve();
    }
  }]);

  return PresenceValidator;
}(_Validator3.default);

PresenceValidator.MESSAGE = '{attribute} - can\'t be blank';
exports.default = PresenceValidator;


//////////////////
// WEBPACK FOOTER
// ./~/rx-model/validators/PresenceValidator.js
// module id = 772
// module chunks = 0